import Vue from "vue";
import base from "./baseIntegration";

export default Object.assign(
    {
        apiUrl: "/establishment",

        async getAll(establishmentId) {
            const url = this.url(`/${establishmentId}/integration/manager`);
            return Vue.http.get(url);
        },

        async update({ establishmentId, integrations }) {
            const url = this.url(`/${establishmentId}/integration/manager`);
            return Vue.http.post(url, integrations);
        },
    },
    base
);
